import { Observable } from 'rxjs/Observable'
import { captureException } from 'utils/SentryHelpers'

import { api } from './api'
import * as actions from './actions'

const fetchOverview = action$ => {
  return action$
    .ofType(actions.fetchOverview.toString())
    .switchMap(() => {
      return api
        .fetch()
        .map(actions.receiveOverview)
        .startWith(actions.fetchOverviewPending())
        .catch(error => {
          captureException(error)
          return Observable.of(actions.fetchOverviewFailed())
        })
    })
}

export const epic = fetchOverview



// WEBPACK FOOTER //
// ./src/scripts/app/modules/org/overview/epic.js